import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { VirtualScrollerModule } from '@iharbeck/ngx-virtual-scroller';

import { I18nModule } from '@recruitee/i18n';
import {
  DropdownComponent,
  DropdownHeaderComponent,
  FormFieldComponent,
  IconComponent,
  InputComponent,
} from '@recruitee/user-interface';

import { EmojiFallbackHtmlPipe } from './emoji-fallback-html/emoji-fallback-html.pipe';
import { EmojiListComponent } from './emoji-list/emoji-list.component';
import { EmojiComponent } from './emoji/emoji.component';

@NgModule({
  imports: [
    CommonModule,
    DropdownComponent,
    DropdownHeaderComponent,
    FormFieldComponent,
    I18nModule,
    IconComponent,
    InputComponent,
    ReactiveFormsModule,
    VirtualScrollerModule,
  ],
  declarations: [EmojiListComponent, EmojiComponent, EmojiFallbackHtmlPipe],
  exports: [EmojiListComponent, EmojiFallbackHtmlPipe, EmojiComponent],
})
export class EmojiModule {}
